<mat-accordion [hideToggle]="true">
  <mat-expansion-panel [expanded]="expanded" (opened)="expanded = true" (closed)="expanded = false">
    <mat-expansion-panel-header class="panel-header">
      <mat-panel-title>
        <terra-icon
          icon="caret-up"
          data-cy="meeting-notes_expander-icon"
          class="rotate"
          [ngClass]="{ 'rotate-90': expanded }" />
        <terra-divider vertical="true" class="vertical-divider" />
        <terra-icon class="notes-icon" icon="notepad" />&nbsp;&nbsp;
        <div class="terra-title">{{ language?.meeting?.item }} Notes</div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    @if (meetingService.currentMeeting) {
      @if (richTextEditorEnabled$ | async) {
        <ninety-rich-text-editor
          ninetyTextEditorBackend
          data-cy="meeting-notes_text-editor"
          variant="medium"
          parentType="Meeting"
          [parentId]="meetingService.currentMeeting._id"
          placeholder="Meeting Notes..."
          [ngModel]="meetingService.currentMeeting.notes"
          [ngModelOptions]="{ standalone: true }"
          (contentChanged)="onNotesChanged($event)"
          [canEdit]="!user?.isObserver"
          [hideToolbarWhenReadOnly]="true"
          [maxHeight]="300" />
      } @else {
        <ninety-text-editor
          data-cy="meeting-notes_text-editor"
          placeholder="Meeting Notes..."
          [(text)]="meetingService.currentMeeting.notes"
          (textChange)="updateMeetingNotes$.next($event)"
          [readonly]="user?.isObserver"></ninety-text-editor>
      }
    }

    @if (meetingIdAndAttachments()) {
      <ninety-file-attachments
        class="top-space-15"
        [item]="meetingIdAndAttachments()"
        parentType="Meeting"
        (attachmentAdded)="onAttachmentAdded($event)"
        (attachmentRemoved)="onAttachmentRemoved($event)"></ninety-file-attachments>
    }
  </mat-expansion-panel>
</mat-accordion>
